'use client';

import { useTranslation } from 'react-i18next';
import { ListPageTitle } from 'ui';

import { useContracts } from '~/contract/hooks/useContracts/useContracts';
import { CustomerPicker, useSelectedCustomerIds } from '~/customer';
import { LayoutSwitcher, ScrollableViewWithData } from '~/ui';

import { ContractList } from './ContractList';

const UserContracts = () => {
  const { t } = useTranslation();

  const { selectedCustomerIds: selectedCustomersIds } = useSelectedCustomerIds();

  return (
    <>
      <ListPageTitle
        title={t('nav.contracts')}
        desktopActions={
          <>
            <CustomerPicker
              sx={{
                mr: 1,
              }}
            />
            <LayoutSwitcher />
          </>
        }
      />

      <ScrollableViewWithData
        useDataHook={useContracts}
        hookOptions={{
          filterBy: { customerIdIn: selectedCustomersIds.join(',') },
          size: 12,
        }}
        ListComponent={ContractList}
      />
    </>
  );
};

export default UserContracts;
